import { Button, mergeClasses } from '@fluentui/react-components';
import { IViaeroButtonProps } from '../ViaeroButton.types';
import useSecondaryButtonStyles from './SecondaryButton.styles';

const SecondaryButton = (props: IViaeroButtonProps) => {
    const { text, click, customStyle, disabled, testId, className } = props;

    const styles = useSecondaryButtonStyles();

    return (
        <Button
            appearance={'outline'}
            onClick={click}
            className={className ? mergeClasses(styles.root, className) : styles.root}
            style={customStyle}
            disabled={disabled}
            data-testid={testId}
        >
            {text}
        </Button>
    );
};

export default SecondaryButton;
